import {Pressable, Text, StyleSheet} from "react-native";
import React from "react";
import {useSelector} from "react-redux";
import {useTheme} from "@react-navigation/native";

export default function ViewCompletedButton(props) {
    const { onPress, title, data } = props;
    const viewCompleted = useSelector(state => state.viewCompleted);
    const theme = useTheme();

    const styles = StyleSheet.create({
        activeButton: {
            backgroundColor: theme.colors.scheme[1]
        },
        activeText: {
            color: '#fff'
        },
        button: {
            width: 128,
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            flexDirection:'row',
            backgroundColor: theme.colors.scheme[4],
            borderWidth:2,
            borderColor: theme.colors.scheme[5],
            fontFamily: 'Roboto-Regular',
            fontSize:16,
            padding:12,
            marginHorizontal:2,
            borderRadius: 100,
            textAlign:'center'
        },
        text: {
            color: theme.colors.scheme[2],
            fontFamily:'Roboto-Light'
        }
    });
    return (//(viewCompleted === data ? [styles.button, styles.activeButton] : null)
        <Pressable style={({pressed}) => [styles.button, (viewCompleted === data ? styles.activeButton : null)]} onPress={onPress}>
            <Text style={(viewCompleted === data ? [styles.text, styles.activeText] : [styles.text])}>{title}</Text>
        </Pressable>
    )
}